module.exports = __webpack_public_path__ + "static/media/anc8kz.80e12944.pdf";